<template>
        <span>
                <!-- <el-button type="text" icon="el-icon-view" @click="openDialog" >查看</el-button> -->
                <el-dialog
                        title="查看"
                        width="65%"
                        
                        :bottom="0"
                        append-to-body
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        查看
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll;">
                <el-form ref="form" label-position="left" :model="form" label-width="110px">
                <el-row>
                        <el-col span="24" v-for="item in columnSlot" :key="item.prop">
                                 <el-form-item :label="item.label"  v-if="item.label=='具体时间' && form.cycleType=='周'">
                                         {{form.weeksName}} 
                                 </el-form-item>
                                 <el-form-item :label="item.label"  v-if="item.label=='具体时间' && form.cycleType=='月'">
                                         {{form.monthsName}}
                                 </el-form-item>
                                 <el-form-item :label="item.label"  v-if="item.label=='初次巡检' && form.cycleType=='自定义'">
                                         {{form[item.prop]}}
                                 </el-form-item>
                                <el-form-item :label="item.label" v-if="item.label!='具体时间' && item.label!='初次巡检'">
                                        
                                        <div v-if="item.prop=='timeQuantum'">
                                                
                                                <el-tag
                                                       
                                                        style="margin-right: 10px;"
                                                        v-for="item in timeQuantum"
                                                        :key="item"
                                                        
                                                        size="medium"
                                                       
                                                >
                                                        {{ item }}
                                                </el-tag>
                                        </div>
                                        
                                        <div v-else>
                                                {{form[item.prop]}}
                                        </div>
                                        <!-- <el-input v-model="form[item.prop]" :readonly="true"></el-input> -->
                                </el-form-item>
                        </el-col>
                        <el-col span="24" >
                                <el-form-item label="分配方式:">
                                       {{form.allotType}}
                                </el-form-item>
                        </el-col>
                        <el-col span="24" v-if='form.standardId' >
                                <el-form-item label="巡检标准:">
                                       {{form.standardName}}
                                </el-form-item>
                        </el-col>
                        <el-col span="24" >
                                <el-form-item label="计划内容">
                                        <avue-crud 
                                        v-if="type ==1 ||type==2"
                                                :data="data" 
                                                :option="option"
                                                ref="crud"
                                        
                                                >
                                                <template slot-scope="scope" slot="name">
                                                      <span>{{scope.row.name}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                                                </template>
                                                <template slot-scope="scope" slot="status">
                                                
                                                        {{(scope.row.inspectFlag==1||scope.row.upkeepFlag==1)? "完成" : ""}}
                                                </template>
                                                <template slot="menu" slot-scope="scope">
                                                        <el-button type="text" icon="el-icon-view" @click="openDetailsDialog(scope.row)" >详情</el-button>
                                                        
                                                </template>

                                        </avue-crud>
                                         <avue-crud 
                                                v-else
                                                        :data="data" 
                                                        :option="optionArea"
                                                        ref="crud"
                                                
                                                        >
                                                        <template slot-scope="scope" slot="status">
                                                                <div style="line-height: 0px;">
                                                                        {{(scope.row.inspectFlag==1||scope.row.upkeepFlag==1)? "完成" : ""}}
                                                                </div>
                                                                
                                                        </template>
                                                        <template slot="menu" slot-scope="scope">
                                                                <el-button type="text" icon="el-icon-view" @click="openDetailsDialog(scope.row)" >详情</el-button>
                                                                
                                                        </template>
                                                        <template slot-scope="scope" slot="deviceName">
                                                                                <span>{{scope.row.deviceName}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                                                        </template>

                                                </avue-crud>
                                </el-form-item>
                        </el-col>
                        <el-col span="24" >
                                <el-form-item label="执行任务要求:">
                                       <el-row>
                                                <el-col span="12">
                                                        <el-row  v-if="form.taskNotifyAheadNum && String(form.taskNotifyAheadNum)!=='0'">
                                                                任务通知时限：任务开始前{{form.taskNotifyAheadNum}}{{taskNotifyAheadUnit}}
                                                        </el-row>
                                                        <el-row v-if="String(form.taskFinishPicMustFlag)==='1'">
                                                                强制提交照片，数量1~4张
                                                        </el-row>
                                                        <el-row v-if="String(form.taskExecuteForceSequenceFlag)==='1'">
                                                                强制按巡检内容书顺序巡检
                                                        </el-row>
                                                </el-col>
                                                <el-col span="12">
                                                        <el-row  v-if="form.taskOverdueTimeNum && String(form.taskOverdueTimeNum)!=='0'">
                                                                任务过期时限：{{form.taskOverdueTimeNum}}{{taskOverdueTimeUnit}}
                                                        </el-row>
                                                        <el-row v-if="String(form.taskOverdueCloseFlag)==='1'">
                                                                逾期任务自动关闭
                                                        </el-row>
                                                        <el-row v-if="String(form.taskOverdueSubmitForbidFlag)==='1'">
                                                                任务过期不允许执行
                                                        </el-row>
                                                </el-col>
                                                
                                       </el-row>
                                </el-form-item>
                        </el-col>
                </el-row>

                </el-form>
                

                <detailForm ref="detailForm"  :projectList.sync="projectList"></detailForm>
                </div>
                </el-dialog>
        </span>
</template>

<script>
import {getPlanDetail,getDictionary,getOrderType} from "@/api/crmedical/device/planManagement";
import detailForm from "./details.vue"
export default {
        components:{detailForm},
        props:{
                id:{
                        type:String,
                        default:"",
                }
        },
        data(){
                return{
                        projectList:[],
                        columnSlot:[],
                        loading:false,
                        dialogFull:false,
                        dialogVisible:false,
                        data:[],
                        form:{},
                        type:1,
                        option:{
                                tip: false,
                                maxHeight:400,
                                cellBtn:false,
                                addBtn:false,
                                header:false,
                                refreshBtn:false,
                                searchBtn:false,
                                searchShowBtn:false,
                                selection:false,
                                selectClearBtn:false,
                                columnBtn:false,
                                index:true,
                                menu:false,
                                menuBtn:false,
                                editBtn:false,
                                delBtn:false,
                                emptyBtn:false,
                                indexLabel:"序号",
                                column:[
                                        {
                                                label: '项目名称',
                                                prop: 'projectId',
                                                searchSlot:true,
                                                typeslot: true,
                                                slot:true,
                                                searchDisabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务类型',
                                                prop: 'type',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务子类型',
                                                prop: 'orderSubModuleName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划名称',
                                                prop: 'planName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划日期',
                                                prop: 'planDate',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划制定人员',
                                                prop: 'createUserName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划制定时间',
                                                prop: 'createTime',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '关联工单类型',
                                                prop: 'orderType',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划周期',
                                                prop: 'cycleType',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '初次巡检',
                                                prop: 'inspection',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '具体时间',
                                                prop: 'cycleRule',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '时间段',
                                                prop: 'timeQuantum',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },

                                        {
                                                label: '计划人员/组',
                                                prop: 'userNames',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                       
                                       
                                        
                                        {
                                                label: '设备名称',
                                                prop: 'name',
                                                slot:true,
                                        },
                                        {
                                                label: '设备编号',
                                                prop: 'code',
                                        },
                                        {
                                                label: '设备类型',
                                                prop: 'typeName',
                                        },

                                        {
                                                label: '所属部门',
                                                prop: 'deptName',
                                        },
                                        {
                                                label: '存放位置',
                                                prop: 'areaName',
                                        },
                                        
                                        {
                                                label: '标准',
                                                prop: 'standardName',
                                        },
                                ]
                        },
                        optionArea:{
                                tip: false,
                                maxHeight:400,
                                cellBtn:false,
                                addBtn:false,
                                header:false,
                                refreshBtn:false,
                                searchBtn:false,
                                searchShowBtn:false,
                                selection:false,
                                selectClearBtn:false,
                                columnBtn:false,
                                index:true,
                                menu:false,
                                menuBtn:false,
                                editBtn:false,
                                delBtn:false,
                                emptyBtn:false,
                                indexLabel:"序号",
                                column:[
                                        {
                                                label: '项目名称',
                                                prop: 'projectId',
                                                searchSlot:true,
                                                typeslot: true,
                                                slot:true,
                                                searchDisabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务类型',
                                                prop: 'type',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务子类型',
                                                prop: 'orderSubModuleName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划名称',
                                                prop: 'planName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划日期',
                                                prop: 'planDate',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划制定人员',
                                                prop: 'createUserName',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划制定时间',
                                                prop: 'createTime',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '关联工单类型',
                                                prop: 'orderType',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划周期',
                                                prop: 'cycleType',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '初次巡检',
                                                prop: 'inspection',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '具体时间',
                                                prop: 'cycleRule',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '时间段',
                                                prop: 'timeQuantum',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },

                                        {
                                                label: '计划人员/组',
                                                prop: 'userNames',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                       
                                       
                                        
                                        {
                                                label: '区域编号',
                                                prop: 'code',
                                        },
                                        {
                                                label: '区域名称',
                                                prop: 'areaName',
                                                
                                        },
                                        
                                         {
                                                label: '区域全称',
                                                prop: 'fullName',
                                        },
                                        

                                        {
                                                label: '所属部门',
                                                prop: 'deptName',
                                        },
                                        
                                        // {
                                        //         label: '执行时间',
                                        //         prop: 'realInspectTime',
                                        // },
                                        // {
                                        //         label: '执行人员',
                                        //         prop: 'realInspectManName',

                                        // },
                                        // {
                                        //         label: '执行时间',
                                        //         prop: 'realUpkeepTime',
                                        // },
                                        // {
                                        //         label: '执行人员',
                                        //         prop: 'realUpkeepManName',
                                        // },
                                        
                                        // {
                                        //         label: '任务结果',
                                        //         prop: 'status',
                                        //         slot:true,
                                        // },
                                ]
                        },
                        projectId:'',
                        timeQuantum:[],
                        taskNotifyAheadUnit:'',
                }
        },
        methods:{
                  //根据工单子类型获取标准
              async  getStandardBysubTypeId(inspectType,projectId){
                      console.log("89898")
                        let data =[]
                     await   getStandardName({
                                projectId,
                                inspectType
                        }).then(res=>{
                                  data = res.data 
                        })
                        return data
                },
                // 打开自己弹窗
                openDialog(row){
                        this.form.projectId = row.$projectId;
                        this.projectId = row.projectId;
                        this.form.type = row.$type;
                        this.type = row.type;
                        this.form.executeUserId = row.executeUserName;
                        this.form.planName = row.name;
                        this.form.cycleType = row.$cycleType;
                        this.form.validStartTime = row.validStartTime;
                        this.form.validEndTime = row.validEndTime;
                        this.form.orderSubModuleId = row.orderSubModuleId;
                        this.form.orderModuleType = row.orderModuleType;
                        this.form.taskNotifyAheadNum =row.taskNotifyAheadNum;
                        this.form.taskNotifyAheadUnit = row.taskNotifyAheadUnit;
                        
                        this.dialogVisible = true;
                        this.initData(row.id);
                },
                // 打开详情弹窗
                openDetailsDialog(row){
                        this.$refs.detailForm.openDialog(row,this.type);
                },
                // 初始化数据
                async initData(id){
                        this.loading = true;
                        let columnSlot = [];
                        this.option.column.forEach(ele=>{
                                if(ele.searchSlot){
                                        columnSlot.push(ele);
                                }
                        })
                        this.columnSlot = columnSlot;
                        
                        
                        await getPlanDetail({id:id}).then(res=>{
                                let data = res.data;
                                this.loading = false;
                                this.form.taskExecuteForceSequenceFlag = data.taskExecuteForceSequenceFlag;
                                this.form.taskOverdueTimeNum = data.taskOverdueTimeNum;
                                this.form.taskOverdueTimeUnit = data.taskOverdueTimeUnit;
                                this.form.taskOverdueCloseFlag = data.taskOverdueCloseFlag;
                                this.form.taskOverdueSubmitForbidFlag = data.taskOverdueSubmitForbidFlag;


                                this.form.createTime = data.createTime
                                this.form.allotType = data.allotType;
                                this.form.createUserName = data.createUserName;
                                this.form.userNames = data.userNames;
                                this.form.taskFinishPicMustFlag = data.taskFinishPicMustFlag;
                                this.timeQuantum = data.timeQuantum.split(",");
                                this.form.orderSubModuleName = data.subTypeName?data.subTypeName:'';
                                this.form.planDate = this.dayjs(data.validStartDate).format('YYYY-MM-DD')+" ~ "+this.dayjs(data.validEndDate).format('YYYY-MM-DD')
                                // this.form.inspection = 
                                if(res.data.cycleType==2){
                                        let cycleRule = JSON.parse(data.cycleRule);
                                        
                                        let temArr = cycleRule.data?cycleRule.data.split(","):[];
                                        temArr.sort();
                                        let weeksName = "";
                                        temArr.forEach(ele=>{
                                                
                                                switch(Number(ele)){
                                                        case 1:weeksName += "周一";break;
                                                        case 2:weeksName += "周二";break;
                                                        case 3:weeksName += "周三";break;
                                                        case 4:weeksName += "周四";break;
                                                        case 5:weeksName += "周五";break;
                                                        case 6:weeksName += "周六";break;
                                                        case 7:weeksName += "周日";break;
                                                }
                                                if(ele != temArr[temArr.length-1]){
                                                        weeksName += " , " 
                                                }
                                        })
                                        this.form.weeksName = weeksName;

                                }else if(res.data.cycleType==3){
                                        let cycleRule = JSON.parse(data.cycleRule);
                                        
                                        let temArr = cycleRule.data?cycleRule.data.split(","):[];
                                        temArr.sort();
                                        let monthsName = temArr.join(",");
                                       
                                        this.form.monthsName = monthsName;
                                }else if(res.data.cycleType==99){
                                        let cycleRule = JSON.parse(data.cycleRule);
                                        this.form.inspection = this.dayjs(cycleRule.firstDate).format("YYYY-MM-DD") 
                                                + " 开始，巡检 " 
                                                + cycleRule.days
                                                + " 天，暂停 "
                                                + cycleRule.pauseDays;
                                       
                                }
                                this.data = res.data.targetList;

                        }).catch(err=>{
                                this.loading = false;
                        })
                        // 任务提前通知时限单位
                        await getDictionary("task_notify_ahead_unit").then(res=>{
                                res.data.forEach(ele=>{
                                        if(ele.dictKey==this.form.taskNotifyAheadUnit){
                                                this.taskNotifyAheadUnit = ele.dictValue
                                        }
                                })
                                
                                
                        })
                        // 任务过期时间单位
                        await getDictionary("task_overdue_time_unit").then(res=>{
                                res.data.forEach(ele=>{
                                        if(ele.dictKey==this.form.taskOverdueTimeUnit){
                                                this.taskOverdueTimeUnit = ele.dictValue
                                        }
                                })
                                
                                
                        })
                        // 分配方式
                        await getDictionary("task_allot_type").then(res=>{
                                 res.data.forEach(ele=>{
                                        if(ele.dictKey==this.form.allotType){
                                                this.form.allotType = ele.dictValue
                                        }
                                })
                                
                        })
                        
                        await getOrderType({taskType:this.type,projectId:this.projectId}).then(res=>{
                                        this.form.orderType = "";

                                        let temArr = [];
                                        let temObj = {};
                                        temObj.label = res.data.orderModuleTypeName;
                                        temObj.value = res.data.orderModuleType;
                                        temObj.children = [];
                                        if(res.data.subModuleList){
                                                res.data.subModuleList.forEach(ele=>{
                                                        let a = {
                                                                label:ele.name,
                                                                value:ele.id
                                                        };
                                                        temObj.children.push(a);

                                                })
                                        }
                                        
                                        temArr.push(temObj);
                                       
                                        temArr.forEach(ele=>{
                                                if(ele.value == this.form.orderModuleType){
                                                        this.form.orderType = ele.label
                                                }
                                                ele.children.forEach(item=>{
                                                        if(item.value==this.form.orderSubModuleId){
                                                                this.form.orderType =this.form.orderType+ " / "+item.label
                                                        }
                                                })
                                        })
                                        this.$forceUpdate(); 
                                        
                                        
                        })
                        console.log(this.columnSlot)
                }
        }
}
</script>